import React from 'react';
import { css } from '@emotion/react';
import TopNav from '@/components/ui/TopNav';
import EmailCard from '@/components/ui/EmailCard';

const emails = [
  {
    image: '/images/emails/email-1.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
  {
    image: '/images/emails/email-2.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
  {
    image: '/images/emails/email-3.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
  {
    image: '/images/emails/email-4.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
  {
    image: '/images/emails/email-5.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
  {
    image: '/images/emails/email-6.png',
    title: 'Personal welcome message',
    status: 'Draft last edited 2 hours ago',
  },
];

const pageStyles = css`
  min-height: 100vh;
  background: #f9f9f6;
`;

const contentStyles = css`
  max-width: 1140px;
  margin: 0 auto;
  padding: 56px 40px;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const headerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const tabsStyles = css`
  display: flex;
  gap: 24px;
`;

const tabStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 28.63px;
  color: #10100f;
  cursor: pointer;
`;

const tabInactiveStyles = css`
  ${tabStyles};
  color: rgba(61, 46, 41, 0.52);
`;

const actionsStyles = css`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const filterGroupStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const textButtonStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 8px;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #10100f;
  background: none;
  border: none;

  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const iconStyles = css`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
`;

const chevronSmallStyles = css`
  width: 10px;
  height: 18px;
  flex-shrink: 0;
`;

const toggleGroupStyles = css`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const toggleStyles = css`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: #10100f;

  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const toggleActiveStyles = css`
  ${toggleStyles};
  background: rgba(58, 58, 44, 0.08);
`;

const toggleIconStyles = css`
  width: 16px;
  height: 18px;
`;

const newEmailButtonStyles = css`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding: 0 17px;
  background: #10100f;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #f9f9f6;

  &:hover {
    background: #2a2a28;
  }
`;

const gridStyles = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 56px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

export default function Home() {
  return (
    <div css={pageStyles}>
      <TopNav />
      <div css={contentStyles}>
        <div css={headerStyles}>
          <div css={tabsStyles}>
            <span css={tabStyles}>My emails</span>
            <span css={tabInactiveStyles}>Folders</span>
          </div>
          <div css={actionsStyles}>
            <div css={filterGroupStyles}>
              <button css={textButtonStyles} type="button">
                <svg css={iconStyles} viewBox="0 0 18 18" fill="none">
                  <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
                  <path
                    d="M13 13L16.5 16.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                Search
              </button>
              <button css={textButtonStyles} type="button">
                Status
                <svg css={chevronSmallStyles} viewBox="0 0 10 6" fill="none">
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div css={toggleGroupStyles}>
              <div css={toggleActiveStyles}>
                <svg css={toggleIconStyles} viewBox="0 0 15 15" fill="none">
                  <rect
                    x="0.5"
                    y="0.5"
                    width="5.5"
                    height="5.5"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                  <rect
                    x="9"
                    y="0.5"
                    width="5.5"
                    height="5.5"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                  <rect
                    x="0.5"
                    y="9"
                    width="5.5"
                    height="5.5"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                  <rect
                    x="9"
                    y="9"
                    width="5.5"
                    height="5.5"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                </svg>
              </div>
              <div css={toggleStyles}>
                <svg css={toggleIconStyles} viewBox="0 0 17 10" fill="none">
                  <path
                    d="M0.5 1H16.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M0.5 5H16.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M0.5 9H16.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div css={toggleStyles}>
                <svg css={toggleIconStyles} viewBox="0 0 16 18" fill="none">
                  <rect
                    x="0.5"
                    y="0.5"
                    width="15"
                    height="17"
                    rx="1.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                  <path d="M0.5 5H15.5" stroke="currentColor" strokeWidth="1.2" />
                  <path d="M5 0.5V5" stroke="currentColor" strokeWidth="1.2" />
                  <path d="M11 0.5V5" stroke="currentColor" strokeWidth="1.2" />
                </svg>
              </div>
            </div>
            <button css={newEmailButtonStyles} type="button">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M7.5 1V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M1 7.5H14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              </svg>
              New email
            </button>
          </div>
        </div>
        <div css={gridStyles}>
          {emails.map(email => (
            <EmailCard key={email.image} {...email} />
          ))}
        </div>
      </div>
    </div>
  );
}
